import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type AppServicesWaldenTraceController from 'walden-fast/controllers/app/services/walden-trace';
import type FastApiService from 'walden-fast/services/fast-api';
import type { TraceOrder } from 'walden-fast/types/trace-order';
import type UserService from 'walden-fast/services/user';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppServicesWaldenTraceModel = Resolved<
  ReturnType<AppServicesWaldenTraceRoute['model']>
>;

export default class AppServicesWaldenTraceRoute extends Route {
  @service('fast-api') declare fastApiService: FastApiService;
  @service('user') declare userService: UserService;

  async model(params: { carrier: string }) {
    const userCanAccessService = this.userService.canAccessService(
      SERVICE_NAMES.WALDEN_TRACE,
    );

    return {
      carrier: params.carrier,
      stats: [],
      orders: userCanAccessService
        ? (await this.fastApiService.get<TraceOrder[]>(
            '/walden-trace/orders',
          )) || []
        : [],
    };
  }

  resetController(controller: AppServicesWaldenTraceController) {
    controller.reset();
  }
}
